import Vue from 'vue'
import App from './App.vue'

const configElement = document.getElementById('vue-app-config')
export const config = new Vue({
  data: JSON.parse(configElement.innerHTML)
})

new Vue({
  el: '#vue-cp-map-app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./main.js